<p class="qundis-inter-400" *ngIf="action() === 'create'">
  Bitte die Produktionslinie definieren
</p>
<form class="admin-form production-line-form" [formGroup]="productionLineForm">
  <mat-form-field appearance="outline">
    <mat-label>Name der Produktionslinie</mat-label>
    <input matInput type="text" formControlName="name" />
  </mat-form-field>
  <mat-form-field>
    <mat-label>Produktionslinien Kürzel</mat-label>
    <input matInput type="text" formControlName="shortcode" />
  </mat-form-field>
  <mat-form-field>
    <mat-label>Produktionsbeschreibung</mat-label>
    <textarea
      matInput
      placeholder="..."
      formControlName="description"
    ></textarea>
  </mat-form-field>
</form>

<app-save-cancel-buttons
  *ngIf="
    this.navigationService.activeComponent() !==
    'productionLineDetailsPageComponent'
  "
  [backRoute]="'/admin/productionLines'"
  (saveEvent)="save()"
></app-save-cancel-buttons>
